// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import VersesIntro from 'components/Verses/VersesIntro'
import VersesInfoButton from 'components/Verses/VersesInfoButton'
import VerseList from 'components/Verses/VerseList'

class VerseListPage extends React.Component {
	render() {
		const { hasSeenVotdIntro } = this.props

		return (
			<div className="votd-page-content">
				{ ! hasSeenVotdIntro &&
					<VersesIntro />
				||
					[
						<VersesInfoButton key="VersesInfoButton" />,
						<VerseList key="VerseList" />
					]
				}
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		hasSeenVotdIntro: state.site.hasSeenVotdIntro
	}
}

export default connect( mapStateToProps )( VerseListPage )
